import React from 'react'

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    useTheme,
} from '@material-ui/core'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

interface Props {
    open: boolean
    isSaving?: boolean
    onCancel: () => void
    onDiscard: () => void
    onSave: () => void
}

export const UnsavedPricingChangesDialog = (props: Props) => {
    const { open, isSaving, onCancel, onDiscard, onSave } = props
    const theme = useTheme()

    return (
        <Dialog
            open={open}
            onClose={isSaving ? undefined : onCancel}
            PaperProps={{
                style: {
                    borderRadius: 12,
                    minWidth: 420,
                    maxWidth: 480,
                    padding: theme.spacing(0.5, 0.5, 0),
                },
            }}
        >
            <DialogTitle disableTypography style={{ paddingBottom: 8 }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            backgroundColor: 'rgba(237, 108, 2, 0.12)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: theme.spacing(1.5),
                            flexShrink: 0,
                        }}
                    >
                        <WarningRoundedIcon
                            style={{ color: theme.palette.warning.main }}
                        />
                    </div>
                    <Typography
                        variant="h6"
                        style={{ fontWeight: 700, lineHeight: 1.3 }}
                    >
                        Save pricing changes?
                    </Typography>
                </div>
            </DialogTitle>
            <DialogContent>
                <Typography
                    style={{
                        color: theme.palette.text.secondary,
                        lineHeight: 1.55,
                    }}
                >
                    You have unsaved vendor pricing. Save your changes, or
                    discard them to leave this screen.
                </Typography>
            </DialogContent>
            <DialogActions
                style={{
                    padding: theme.spacing(2),
                    paddingTop: theme.spacing(1),
                }}
            >
                <Button
                    onClick={onCancel}
                    disabled={isSaving}
                    style={{ textTransform: 'none' }}
                >
                    Keep editing
                </Button>
                <div style={{ flex: 1 }} />
                <Button
                    onClick={onDiscard}
                    disabled={isSaving}
                    variant="outlined"
                    color="secondary"
                    style={{ textTransform: 'none' }}
                >
                    Discard
                </Button>
                <Button
                    onClick={onSave}
                    disabled={isSaving}
                    variant="contained"
                    style={{
                        textTransform: 'none',
                        backgroundColor: '#008C85',
                        color: 'white',
                        minWidth: 128,
                    }}
                >
                    {isSaving ? (
                        <CircularProgress size={18} color="inherit" />
                    ) : (
                        'Save changes'
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
